import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'utils/common';
import {  useSelector } from 'react-redux';
import {toTitleCase} from "utils/common"

export default function useExpensesFilter(pageSettings , setPageSettings) {
    const [searchParams, setSearchParams] = useSearchParams();
    const {
        department, departmentLoading,
        reportTo, reportToLoading,
        nationality, nationalityLoading,
        position, positionLoading,
        division, divisionLoading,
        userData, userDataLoading
        
    } = useSelector((state) => state.common);

    const [filterLoading, setFilterLoading] = useState(false)
    const [isFilterDirty, setIsFilterDirty] = useState(false)
  const [filters, setFilters] = useState([
    {
        key: "claim_no",
        label: "Search term",
        value: searchParams.get("claim_no") || ""
    },
    {
        key: "reference_date",
        label: "Ref date",
        value: searchParams.get("reference_date") || ""
    },
    {
        key: "posting_date",
        label: "Posting date",
        value: searchParams.get("posting_date") || ""
    },
   
    {
        key: "approval_status",
        label: "Approval Status",
        value: searchParams.get("approval_status") || ""
    },
    {
        key: "current_approver",
        label: toTitleCase(searchParams.get("current_approver") || ""),
        value: searchParams.get("current_approver") || ""
    },
    {
        key: "company_user",
        label: toTitleCase(searchParams.get("company_user") || ""),
        value: searchParams.get("company_user") || ""
    },
    {
        key: "search",
        label: toTitleCase(searchParams.get("search") || ""),
        value: searchParams.get("search") || ""
    }
  ]);

  useEffect(()=>{

    if(!userDataLoading ){
        let selectedUserData = [...userData].find(item=>item.id == searchParams.get("company_user") || "")
        let _current_approver = [...userData].find(item=>item.id == searchParams.get("current_approver") || "")


        let _filters = [
            {
                key: "search",
                label: "Search",
                value: searchParams.get("search") || ""
            },
            {
                key: "reference_date",
                label: "Ref date",
                value: searchParams.get("reference_date") || ""
            },
            {
                key: "posting_date",
                label: "Posting date",
                value: searchParams.get("posting_date") || ""
            },
            {
                key: "company_user",
                 label: selectedUserData?.first_name+" "+selectedUserData?.last_name,
                value: searchParams.get("company_user") || ""
            },
           
            {
                key: "current_approver",
                 label: _current_approver?.first_name+" "+_current_approver?.last_name,
                value: searchParams.get("current_approver") || ""
            },
            
            {
                key: "approval_status",
                label: "Approval status",
                value: searchParams.get("approval_status") || ""
            },
          ]

       
          setFilters(_filters)
    }

 
  },[
    userData
  ])

  const handleFilterChange =  (data, key, make_call=false) => {

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    console.log( selectedFilter,data, key, "AAAA")

    if(Array.isArray(data)){
        // selectedFilter['label'] = data?.label || ""
        selectedFilter['value'] = data

    }else{
        selectedFilter['label'] = data?.label || ""
        selectedFilter['value'] = data?.value || ""
    }


    setFilters(_filters)
    console.log( _filters, "AAAA")
    if(make_call){
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }


  };
  const handleInputChange = debounce((data, key, make_call=false) => {
    console.log( "FFFF")

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){


        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }

  }, 1000)

  const handleDateChange = (data, key, make_call=false) => {

    console.log("---filterssss--->>>>", [...filters])
    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){


        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }

  }

  // Clear All only resets the draft fields inside the drawer - it must
  // NOT trigger a search. The actual API call happens when the user
  // clicks Apply Filter.
  const handleClearAll = () => {
    const hadValues = filters.some(filter => filter.key !== "search" && (Array.isArray(filter.value) ? filter.value.length > 0 : !!filter.value))
    let clearedFilters = filters.map(filter => ({
      ...filter,
      value: Array.isArray(filter.value) ? [] : "",
      label: filter.key === "search" ? "Search term" : ""
    }))
    setFilters(clearedFilters)
    if(hadValues){
      setIsFilterDirty(true)
    }
  }

  return {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading, setFilterLoading,
    handleDateChange,
    handleClearAll,
    isFilterDirty, setIsFilterDirty
  };
}
